import { apicall } from "../../services/api";
import {
  GET_BHARAT_STATES,
  GET_BHARAT_CONSTITUENCY,
  GET_BHARAT_MP,
  ERR_BHARAT_POLL,
} from "../actions/actionTypes";

export const getAllStates = () => async (dispatch) => {
  try {
    const res = await apicall(`/polls/bharat/states`, "get");
    if (res.data.msg === "States found.") {
      dispatch({
        type: GET_BHARAT_STATES,
        payload: res.data.data,
      });
    } else {
      dispatch({
        type: GET_BHARAT_STATES,
        payload: res.data.data,
      });
    }
  } catch (err) {
    dispatch({
      type: ERR_BHARAT_POLL,
      payload: { msg: "error in get all states", status: err.response.status },
    });
  }
};

export const getAllConstituency = (state_id) => async (dispatch) => {
    try {
    const res = await apicall(
      `/polls/bharat/details/state?queryState=${state_id}`,
      "get"
    );
    if (res.data.msg === "Constituencies found.") {
      dispatch({
        type: GET_BHARAT_CONSTITUENCY,
        payload: res.data.data,
      });
    } else {
      dispatch({
        type: GET_BHARAT_CONSTITUENCY,
        payload: res.data.data,
      });
    }
  } catch (err) {
    dispatch({
      type: ERR_BHARAT_POLL,
      payload: {
        msg: "error in get all constituencies",
        status: err.response.status,
      },
    });
  }
};

export const getAllConstituenciesMP =
  (constituency_id) => async (dispatch) => {
      try {
      const res = await apicall(
        `/polls/bharat/details/constituency?queryState=${constituency_id}`,
        "get"
        );
      if (res.data.msg === "MPs found.") {
        dispatch({
          type: GET_BHARAT_MP,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: GET_BHARAT_MP,
          payload: res.data.data,
        });
      }
    } catch (err) {
      dispatch({
        type: ERR_BHARAT_POLL,
        payload: {
          msg: "error in geting constituencies mp",
          status: err.response.status,
        },
      });
    }
  };
